module.exports = __webpack_public_path__ + "img/icon1.0e4a339a.png";